import React from 'react'
import './NoQuoteAvailable.scss'

export default function NoQuoteAvailable(props) {
  return (
    <div className="no-quote-container">
      <h5>No quotes available</h5>
      {props.subText &&
        <p> {props.subText}</p>
      }
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Quoters/Common/SubComponents/NoQuoteAvailable.js